// extracted by mini-css-extract-plugin
module.exports = {"audioTags":"FileDetails-audioTags-1vV9t","filename":"FileDetails-filename-1rlY- DescriptionListItemDescription-description-3Ul_p"};